'use es6';

import enviro from 'enviro';

function getIsLocal() {
  try {
    return localStorage.getItem('UPGRADE_IFRAME_ENV') === 'local';
  } catch (e) {
    return false;
  }
}

export var getIframeModalHost = function getIframeModalHost() {
  var host = enviro.isQa() ? 'hubspotqa.com' : 'hubspot.com';
  return getIsLocal() ? "local." + host : "app." + host;
};